import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrendingUp } from 'lucide-react';
import { Badge } from './ui/badge';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const CampaignCard = ({ campaign }) => {
  const { language } = useLanguage();
  const t = translations[language];
  
  // Get translated campaign data from API structure
  const translatedCampaign = campaign.translations && campaign.translations[language] 
    ? campaign.translations[language]
    : {};
  
  // Get the most impactful/killer number from results
  const killerMetric = campaign.results[0]; // First result is usually the most impressive
  
  // Get short description in current language
  const shortDescription = translatedCampaign.shortDescription || campaign.shortDescription;
  
  return (
    <Link to={`/campaign/${campaign.id}`} className="group">
      <div className="bg-white rounded-xl overflow-hidden border border-slate-200 hover:border-teal-400 transition-all duration-300 hover:shadow-xl">
        {/* Image */}
        <div className="aspect-video overflow-hidden bg-slate-100 relative">
          <img 
            src={campaign.thumbnail} 
            alt={campaign.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          {/* Killer Number Overlay */}
          <div className="absolute top-4 right-4 bg-teal-600 text-white px-4 py-2 rounded-lg shadow-lg">
            <div className="flex items-center gap-1">
              <TrendingUp className="w-4 h-4" />
              <span className="font-bold text-lg">{killerMetric.value}</span>
            </div>
            <div className="text-xs opacity-90">{killerMetric.metric}</div>
          </div>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <div className="flex items-center gap-2 mb-3">
            <Badge variant="secondary" className="text-xs">{campaign.category}</Badge>
            <span className="text-xs text-slate-500">{campaign.year}</span>
          </div>
          
          <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:text-teal-600 transition-colors">
            {campaign.title}
          </h3>
          
          {campaign.subtitle && (
            <p className="text-lg text-slate-700 font-medium mb-3">{campaign.subtitle}</p>
          )}
          
          <p className="text-sm text-teal-600 font-medium mb-3">{campaign.brand}</p>
          
          <p className="text-slate-600 text-sm leading-relaxed mb-4">
            {shortDescription}
          </p>
          
          <div className="flex items-center gap-2 text-teal-600 font-medium text-sm group-hover:gap-3 transition-all">
            {t.portfolio.viewCaseStudy}
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CampaignCard;